<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .background-tab {
    height: 100%;
    overflow: auto;
    padding-top: utils.in_rem(16px);
  }
</style>

<script>
  // Components
  import TabPanel from "@sourcewhale/shared/svelte-design-system/components/molecules/TabPanel.svelte";
  import Education from "./Education.svelte";
  import Experience from "./Experience.svelte";

  const tabItems = [
    { label: "Experience", slot: "experienceTab", snippet: experienceSnippet },
    { label: "Education", slot: "educationTab", snippet: educationSnippet },
  ];
</script>

{#snippet experienceSnippet()}
  <Experience />
{/snippet}

{#snippet educationSnippet()}
  <Education />
{/snippet}

<div class="background-tab">
  <TabPanel type="secondary-pill" size="small" {tabItems} />
</div>
